export const configuration = {
  linkPolicy: {
    allowList: false,
    URLs: [],
  },
  preferences: {
    pageSize: 25,
    theme: "sensu",
  },
};
